import { render, staticRenderFns } from "./PosArticleList.vue?vue&type=template&id=2209039f&"
import script from "./PosArticleList.vue?vue&type=script&lang=js&"
export * from "./PosArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports